import { render, staticRenderFns } from "./platformServeList.vue?vue&type=template&id=0150fb18"
import script from "./platformServeList.vue?vue&type=script&lang=js"
export * from "./platformServeList.vue?vue&type=script&lang=js"
import style0 from "./platformServeList.vue?vue&type=style&index=0&id=0150fb18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports